/**
 * FAQ View Component
 * Displays FAQs as buttons
 */
import React from 'react';
import { translations } from '../translations';

const FAQView = ({ faqs, onSelect, language, isLoading }) => {
  const t = translations[language] || translations.en;

  if (faqs.length === 0) {
    return (
      <div className="afgcoin-chatbot-faq-loading">
        <p>{t.loading}</p>
      </div>
    );
  }

  return (
    <div className="afgcoin-chatbot-faq-view">
      <p className="afgcoin-chatbot-prompt">{t.faq.prompt}</p>
      <div className="afgcoin-chatbot-faq-buttons">
        {faqs.map((faq) => (
          <button
            key={faq.id}
            className="afgcoin-chatbot-faq-button"
            onClick={() => onSelect(faq.id)}
            disabled={isLoading}
          >
            {faq.question}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FAQView;

